<template>
  <div
    class="team-member-card d-flex flex-column rounded-sm gr-2 pa-6 cursor-pointer"
    @click="emit('click')"
  >
    <a
      v-if="adminkaUrl"
      :href="adminkaUrl"
      class="adminka align-self-start"
      target="_blank"
      rel="noopener noreferrer"
      @click.stop
    >править</a>
    <p class="text-body-1 text--text">
      {{ transDynamic(teamMember, `first_name,${language},${needTranslate}`) }}
      {{ transDynamic(teamMember, `last_name,${language},${needTranslate}`) }}
    </p>
    <p class="text-body-2 text--text">
      {{ transDynamic(teamMember, `position,${language},${needTranslate}`) }}
    </p>
    <v-img
      class="flex-grow-0 mt-auto rounded-circle"
      lazy-src="/static/_v1/pd/pictures/stubs/person-photo.png"
      :alt="`${transDynamic(teamMember, `first_name,${language},${needTranslate}`)} ${transDynamic(teamMember, `last_name,${language},${needTranslate}`)} ${transDynamic(teamMember, `position,${language},${needTranslate}`)}`"
      :src="teamMember.photo.url"
      width="200"
      height="200"
    />
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'
import transDynamic from 'djanjucks/filters/transDynamic'
import { useContextStore } from 'src/store'
import type { ContextStore, TeamMember } from 'src/components/pages/info/about-us/index/types'

const { language } = I18NextVue
const { context }: ContextStore = useContextStore()
const needTranslate = context.feature_flags.pd_l10n_footer_pages

defineProps<{
  adminkaUrl?: string
  teamMember: TeamMember
}>()

type Emits = {
  (_event: 'click'): void
}

const emit = defineEmits<Emits>()
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.team-member-card {
  width: 255px;
  height: 350px;
  background: linear-gradient($ui-kit-bg-gray-40 0%, $ui-kit-bg-gray-0 100%);
}
</style>
